import React from "react";
import { Switch } from "@material-ui/core";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect } from "../../../../../../_helpers/Helpers";

export function FamilyMemberBasicInfoForm({
  familyMemberName,
  familyMember,
  handleChange,
  values
 }) {
  const isDead = familyMemberName + ".isDead";
  const tcKimlikNo = familyMemberName + ".tcKimlikNo";
  const name = familyMemberName + ".name";
  const surname = familyMemberName + ".surname";
  const phone1 = familyMemberName + ".phone1";
  const phone2 = familyMemberName + ".phone2";
  const email = familyMemberName + ".email";
  const occupationCategory = familyMemberName + ".occupationCategory";
  const occupationCategoryId = familyMemberName + ".occupationCategoryId";
  const occupation = familyMemberName + ".occupation";
  
  return (
    <>
      {
        familyMemberName === "other" ||
        <div className="row">
          <div className="col-6">
            <Form.Group as={Row} controlId={isDead}>
              <Form.Label column sm={3}>
                Yok
              </Form.Label>
              <Col sm={9}>
                <Switch checked={values.isDead} onChange={handleChange(isDead)} />
              </Col>
            </Form.Group> 
          </div>
        </div>
      }

      <div className="row">
        <div className="col-6">
          <Form.Group as={Row} controlId={tcKimlikNo}>
            <Form.Label column sm={3}>
              TC Kimlik No
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.tcKimlikNo} placeholder="TC Kimlik No" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId={name}>
            <Form.Label column sm={3}>
              Adı <span>*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId={surname}>
            <Form.Label column sm={3}>
              Soyadı <span>*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.surname} placeholder="Soyadı" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId={phone1}>
            <Form.Label column sm={3}>
              Cep Telefonu 1
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.phone1} placeholder="Cep Telefonu 1" onChange={handleChange} />
            </Col>
          </Form.Group>
        </div>

        <div className="col-6">
          <Form.Group as={Row} controlId={phone2}>
            <Form.Label column sm={3}>
              Cep Telefonu 2
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.phone2} placeholder="Cep Telefonu 2" onChange={handleChange} />
            </Col>
          </Form.Group>
                  
          <Form.Group as={Row} controlId={email}>
            <Form.Label column sm={3}>
              Email
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.email} placeholder="Email" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId={occupationCategory}>
            <Form.Label column sm={3}>
              Meslek Kategorisi
            </Form.Label>
            <Col sm={9}>
              <CustomSelect 
                options={familyMember.occupationCategories}
                value={values.occupationCategoryId}
                onChange={option => handleChange(occupationCategoryId)(option.value)}
              />
            </Col>
          </Form.Group>              
          
          <Form.Group as={Row} controlId={occupation}>
            <Form.Label column sm={3}>
              Mesleği
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.occupation} placeholder="Mesleği" onChange={handleChange} />
            </Col>
          </Form.Group>
        </div>
      </div>
    </>
  );
}